import React from 'react'

import { IFormFocusTargetContext } from './form-focus-target'

export { IFocusTarget, IFormFocusTargetContext } from './form-focus-target'
export {
  IFormFocusHandle,
  FormFocusHandleContext,
  FormFocusHandleSetter,
} from './form-focus-handle'
export { useFormFocusHandle } from './use-form-focus-handle'

// No-op default so consumers of FormFocusTargetContext (e.g. entity-form-block
// reading focusFirstError via contextType) are safe when no provider is
// mounted above them.
const defaultContext: IFormFocusTargetContext = {
  register: () => undefined,
  unregister: () => undefined,
  getRef: () => null,
  getOrderedPaths: () => [],
  focusPath: () => Promise.resolve(false),
  focusFirstError: () => Promise.resolve(undefined),
}

export const FormFocusTargetContext = React.createContext<IFormFocusTargetContext>(defaultContext)
